/*
* A function that will parse the list of hierarchical categories
* attached to a given artefact from an SDMX_JSON categorisations and
* category schemes structure message.
*
* @memberOf SDMXJS
* @api public
* @tag data
* @param {Object}
* @return {Array}
*
*@example
* const params = {
*  artefactId: 'Ag:Df(1.0)',
*  data: {
*   categorisations: [
*     { source: 'sdmx.urn=Ag:Df(1.0)', target: 'sdmx.urn=Ag:Sc(1.0).Cat' },
*   ],
*   categorySchemes: [{
*     agencyID: 'Ag',
*     id: 'Sc',
*     version: '1.0',
*     categories: [{ 
*       id: 'Cat',
*       name: 'Category',
*     }]
*   }]
* }
*});
*
* SDMXJS.getArtefactCategories(params);
* //=> [{ id: 'Cat', name: 'Category' }]
*/
import * as R from 'ramda';
import { parseCategorisations } from './parseCategorisations';
export var getArtefactCategories = function getArtefactCategories(_ref) {
  var artefactId = _ref.artefactId,
    _ref$data = _ref.data,
    data = _ref$data === undefined ? {} : _ref$data;
  var categorisations = parseCategorisations({
    data: data
  });
  var categorySchemes = R.indexBy(R.pipe(R.props(['agencyID', 'id', 'version']), function (_ref2) {
    var agency = _ref2[0],
      code = _ref2[1],
      version = _ref2[2];
    return agency + ':' + code + '(' + version + ')';
  }))(R.propOr([], 'categorySchemes', data));
  var getHierarchicalCategories = function getHierarchicalCategories(_ref3) {
    var categories = _ref3.categories,
      ids = _ref3.ids;
    if (R.isEmpty(categories) || R.isEmpty(ids)) {
      return [];
    }
    var id = R.head(ids);
    var category = R.find(R.propEq('id', id), categories);
    if (R.isNil(category)) {
      return [];
    }
    var children = getHierarchicalCategories({
      categories: R.propOr([], 'categories', category),
      ids: R.tail(ids)
    });
    return R.prepend({
      id: id,
      name: R.prop('name')(category)
    }, children);
  };
  return R.reduce(function (acc, _ref4) {
    var schemeId = _ref4.schemeId,
      path = _ref4.path;
    var scheme = R.prop(schemeId, categorySchemes);
    if (R.isNil(scheme)) {
      return acc;
    }
    var categories = getHierarchicalCategories({
      categories: scheme.categories,
      ids: R.split('.', path)
    });
    if (R.isEmpty(categories)) {
      return acc;
    }
    var name = R.prop('name')(scheme);
    return [].concat(acc, [R.prepend({
      id: scheme.id,
      name: name
    }, categories)]);
  }, [], R.propOr([], artefactId, categorisations));
};